import React from "react";
import styles from "../styles/settings.module.scss";
import { FaBan, FaCheck } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const SettingCalendar = props => {
  const colors = ["#F9C00C", "#FF585D", "#7200DA", "#68D2DF", "#75D701"];
  const img_ =
    props.type === "Google" ? "/images/gcalendar.png" : props.type === "Liveli" ? "/images/calendar.png" : "/images/outlook.png";
  const btn_color = props.connect ? "red" : "#68D2DF";
  const email = props.connect ? props.email : "Not Linked";
  return (
    <>
      <section className={styles.__set_cal}>
        <section className={styles.__set_cal__des}>
          <img src={img_} alt="ocalendar" />
          <p className={styles.__txt_calemdar}>{props.type} Calendar</p>
        </section>
        <section className={styles.__set_cal__mail}>
                {props.connect ? (
                <MdEmail size={24} color={"#BFBFBF"} />
                ) : (
                <FaBan size={24} color={"red"} />
                )}
                <small>{email}</small>
        </section>
        <section className={styles.__set_cal__link}>
          { props.type !== 'Liveli' &&
          <a
            href={props.href}
            target={props.target}
            className={styles.__btn_connect}
            onClick={props.onClickConnect}
            style={{
              background: btn_color,
              color: props.connect ? "white" : "black"
            }}
          >
            {props.connect ? "Unlink" : "Link"}
          </a>
          }
          {
            props.type === 'Liveli' && 
            <div style={{height: 20}}></div>
          }
        </section>
        <section className={styles.__set_cal__color}>
          <small style={{ opacity: props.connect ? "1" : "0.5" }}>
            Select Badge Color
          </small>
          <section
            style={{ opacity: props.connect ? "1" : "0.5" }}
            className={styles.__set_colors}>
                <div
                className={[
                  styles.__badge_color,
                  props.connect ? styles.__is_disabled : ""
                ].join(" ")}
                style={{ backgroundColor: colors[0] }}
                onClick={() => props.onClickColor(colors[0], props.type)}
              >{
                  props.color === colors[0] &&
                  <FaCheck size={15} color={"white"} style={{margin: 'auto'}}/>
                }</div>
              <div
                className={[
                  styles.__badge_color,
                  props.connect ? styles.__is_disabled : ""
                ].join(" ")}
                style={{ backgroundColor: colors[1] }}
                onClick={() => props.onClickColor(colors[1], props.type)}
              >{
                props.color === colors[1] &&
                <FaCheck size={15} color={"white"} style={{margin: 'auto'}}/>
              }</div>
              <div
                className={[
                  styles.__badge_color,
                  props.connect ? styles.__is_disabled : ""
                ].join(" ")}
                style={{ backgroundColor: colors[2] }}
                onClick={() => props.onClickColor(colors[2], props.type)}
              >{
                props.color === colors[2] &&
                <FaCheck size={15} color={"white"} style={{margin: 'auto'}}/>
              }</div>
              <div
                className={[
                  styles.__badge_color,
                  props.connect ? styles.__is_disabled : ""
                ].join(" ")}
                style={{ backgroundColor: colors[3] }}
                onClick={() => props.onClickColor(colors[3], props.type)}
              >{
                props.color === colors[3] &&
                <FaCheck size={15} color={"white"} style={{margin: 'auto'}}/>
              }</div>
              <div
                className={[
                  styles.__badge_color,
                  props.connect ? styles.__is_disabled : ""
                ].join(" ")}
                style={{ backgroundColor: colors[4] }}
                onClick={() => props.onClickColor(colors[4], props.type)}
              >{
                props.color === colors[4] &&
                <FaCheck size={15} color={"white"} style={{margin: 'auto'}}/>
              }</div>
          </section>
        </section>
        {!props.connect && (
        <div className={styles.__alert_message}>
          Connect your {props.type} Calendar to assign a badge color.
        </div>
      )}
      {props.connect && props.color === null && (
        <div className={styles.__alert_message} style={{ color: "black" }}>
          Assign a badge color to continue please.
        </div>
      )}
      </section>
    </>
  );
};

export default SettingCalendar;
